import { useEffect, useState } from 'react';
import { SharedValue, useAnimatedStyle, useSharedValue, withTiming } from 'react-native-reanimated';
import { ColorTypography } from 'src/theme-v2/color-typography';
import { Alerts, Neutrals } from 'src/theme-v2/colors';

export const useDiscountScaleProgressMiniMilestoneLogic = (
  index: number,
  steps: number,
  progressSV: SharedValue<number>,
  anyMilestoneShowingCheckSV: SharedValue<boolean>,
  lastReachedMilestone?: number | null,
) => {
  const left = (index / (steps - 1)) * 100;
  const showCheckSV = useSharedValue(0);

  useEffect(() => {
    if (lastReachedMilestone === index) {
      anyMilestoneShowingCheckSV.value = true;

      showCheckSV.value = withTiming(1, { duration: 250 });

      setTimeout(() => {
        showCheckSV.value = withTiming(0, { duration: 350 });
        anyMilestoneShowingCheckSV.value = false;
      }, 1500);
    }
  }, [lastReachedMilestone, index]);

  const milestoneAnimatedStyle = useAnimatedStyle(() => {
    const isActive = progressSV.value >= left;
    const backgroundColor = showCheckSV.value === 1;
    return {
      backgroundColor: backgroundColor
        ? Alerts.Green500
        : isActive
          ? ColorTypography.TextColorPromo
          : Neutrals.coldGreys.GreyCold200,
      transform: [
        {
          scale: withTiming(showCheckSV.value === 1 ? 1.25 : 1, { duration: 250 }),
        },
      ],
    };
  });

  const textAnimatedStyle = useAnimatedStyle(() => {
    const isActive = progressSV.value >= left;
    return {
      color:
        showCheckSV.value > 0
          ? Alerts.Green500
          : isActive
            ? ColorTypography.TextColorPromo
            : ColorTypography.TextColorTertiary,
    };
  });

  const checkAnimatedStyle = useAnimatedStyle(() => {
    const opacity = showCheckSV.value;
    return {
      opacity: withTiming(opacity, { duration: 200 }),
      transform: [
        {
          scale: withTiming(opacity ? 1 : 0.5, { duration: 200 }),
        },
      ],
    };
  });

  const [confettiLayout, setConfettiLayout] = useState<{ width: number; height: number } | null>(null);
  const showConfetti = lastReachedMilestone === index;

  const onLayout = e => {
    const { width, height } = e.nativeEvent.layout;
    setConfettiLayout({ width, height });
  };

  return {
    left,
    milestoneAnimatedStyle,
    textAnimatedStyle,
    checkAnimatedStyle,
    confettiLayout,
    showConfetti,
    onLayout,
  };
};
